<div id="report-extract" class="page-layout carded fullwidth">
  <div
    fxFill
    style="background-color: #fafafa; z-index: 1; position: absolute"
  ></div>
  <div class="top-bg mat-accent-bg"></div>

  <div class="center" fxFlex>
    <div
      class="header white-fg"
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayout.gt-xs="row"
      fxLayoutAlign.gt-xs="space-between center"
    >
      <!-- APP TITLE -->
      <div fxLayout="column" fxLayoutAlign="start start">
        <div
          class="logo my-12 m-sm-0"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <span id="txtContentTitle" class="logo-text h1" *fuseIfOnDom>{{
            title
          }}</span>
        </div>
      </div>
      <!-- / APP TITLE -->
    </div>
    <div
      class="content-card mat-white-bg"
      style="padding: 0px 0px 24px 0px"
      fusePerfectScrollbar
    >
      <div
        class="p-24 m-0"
        style="flex-grow: 1; display: flex; flex-direction: column"
      >
        <form
          class="extract-form"
          [formGroup]="form"
          #formControl="ngForm"
          fxLayout="column"
          style="gap: 4px; line-height: 0px !important"
        >
          <div class="pb-24">
            Please specify the requirements for your extract.
          </div>
          <mat-form-field class="pt-16" style="width: 275px">
            <mat-label>Select Dataset for Extract</mat-label>
            <mat-select
              class="form-control"
              formControlName="dataset"
              name="dataset"
              (selectionChange)="datasetChange($event)"
              required
            >
              <mat-option
                *ngFor="let item of datasetList"
                [value]="item.name"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <validation-errors
            class="pt-8"
            [control]="form.get('dataset')"
          ></validation-errors>

          <mat-form-field
            class="pt-16"
            style="width: 275px"
            *ngIf="showProcessList"
          >
            <mat-label>Select Processes for Extract</mat-label>
            <mat-select
              class="form-control"
              formControlName="process"
              name="process"
              (openedChange)="processChange($event)"
              [multiple]="processList?.length > 1"
              required
            >
              <mat-option
                *ngIf="processList?.length > 1"
                #allProcessesSelected
                (click)="toggleProcessAllSelection()"
                [value]="0"
                style="border-bottom: 1px solid; border-color: lightgray"
                >Select All</mat-option
              >
              <mat-option
                *ngFor="let item of processList"
                [value]="item.name"
                (click)="toggleProcessPerOne()"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <validation-errors
            class="pt-8"
            [control]="form.get('process')"
          ></validation-errors>
          <div>
            <div class="pt-16" style="width: 275px">
              <app-intec-date-picker
                class="form-control datepicker"
                [placeholder]="'Select From Date for Extract'"
                formControlName="dateFrom"
                required
              ></app-intec-date-picker>
              <mat-error *ngIf="form.get('dateFrom')?.errors?.required" class="validation-error-msg">
                Required
              </mat-error>
            </div>
            <div class="pt-16" style="width: 275px">
              <app-intec-date-picker
                class="form-control datepicker"
                [placeholder]="'Select To Date for Extract'"
                formControlName="dateTo"
                required
              ></app-intec-date-picker>
              <mat-error *ngIf="form.get('dateTo')?.errors?.required" class="validation-error-msg">
                Required
              </mat-error>
            </div>
            <mat-error *ngIf="form.errors?.minmaxerror" class="validation-error-msg">
                The date from value cannot be greater than the date to value.
            </mat-error>
          </div>

          <div *ngIf="showIncludeArchive">
            <mat-checkbox
              class="my-8"
              id="chkIncludeArchived"
              formControlName="includeArchived"
              name="includeArchived"
              >Include Archived</mat-checkbox
            >
          </div>
        </form>

        <div>
          <button
            mat-raised-button
            type="submit"
            [disabled]="!form.valid || form.pristine"
            (click)="generateExtract()"
            class="save-button mat-accent"
            style="margin-top: 20px"
            aria-label="SAVE"
          >
            GENERATE EXTRACT
          </button>
        </div>

        <div class="progressBarContainer" *ngIf="hasExtractStarted">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
    </div>
  </div>
</div>
